import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Utils
import { translation } from '../../../../utils/helpers'
import { OrderTypeIcons } from '../../../elements/icons'

// Elements
import Grid from '../../../elements/grid'
import Radio from '../../../elements/radio'
import Icon from '../../../elements/icon'
import LabelWrapper from '../../../elements/labelWrapper'

class OrderTypes extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }

    this.onInputChange = this.onInputChange.bind(this)
  }

  onInputChange (e) {
    const { value } = e.target

    if (value === '5' || value === '4') {
      this.props.updateState({
        evaluationAllowed: false,
        Estimation: '0'
      })
    } else {
      this.props.updateState({
        evaluationAllowed: true
      })
    }

    this.props.onInputChange(e)
  }

  renderOrderType (type, dictionaryKey, img, inline) {
    const display = this.props.bodyShop ? 'display_img' : ''
    const id = 'order_type-' + type
    let label = (
      <Grid cols={['min-content', 1]}>
        <span className={display}><Icon icon={img} /></span>
        <span>{translation(dictionaryKey)}</span>
      </Grid>
    )

    return (
      <Radio labelText={label} id={id} size='m' name='OrderType' value={type} onChange={this.onInputChange} checked={this.props.selected === type} />
    )
  }

  render () {
    return (
      <LabelWrapper labelText={525}>
        {this.renderOrderType('1', '13360', OrderTypeIcons.Insurance_black, true)}
        {this.renderOrderType('2', '71', OrderTypeIcons.Salescar_black, true)}
        {this.renderOrderType('3', '13361', OrderTypeIcons.Garanteed_black, true)}
        {this.renderOrderType('6', '785', OrderTypeIcons.Private_black, true)}
        {this.renderOrderType('4', '14980', OrderTypeIcons.Other_black, true)}
        {this.renderOrderType('5', '301', OrderTypeIcons.Complaint_black, true)}
      </LabelWrapper>
    )
  }
}

OrderTypes.propTypes = {
  selected: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
  updateState: PropTypes.func.isRequired
}

export default OrderTypes



// WEBPACK FOOTER //
// ./src/app/shared/modals/NewOrdersModal/OrderTypes/index.js